import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import BlueButton from "../buttons/BlueButton";
import { useClerk } from "@clerk/clerk-react";
import "./Navbar.css";
import BlueOutlinedButton from "../buttons/BlueOutlinedButton";
import { IoClose, IoMenu } from "react-icons/io5";

const HomeNav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeMenuItem, setActiveMenuItem] = useState("");
  const { openSignIn } = useClerk();

  const handleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLoginModel = () => {
    openSignIn();
  };

  useEffect(() => {
    const element = document.getElementById(activeMenuItem);
    if (element) {
      const rect = element.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const targetScrollPosition = rect.top + scrollTop - 70;

      window.scrollTo({
        top: targetScrollPosition,
        behavior: "smooth",
      });
    } else {
    }
  }, [activeMenuItem]);

  return (
    <>
      <nav className="bg-white dark:bg-gray-900 fixed w-full z-20 top-0 start-0 border-b border-gray-200 dark:border-gray-600">
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
          <span className="flex items-center space-x-3 rtl:space-x-reverse">
            <Link to="/">
              <div className="logo-container">
                <span className="self-center text-2xl whitespace-nowrap logo">
                  Comicfy
                </span>
              </div>
            </Link>
          </span>
          <div className="flex lg:order-2 space-x-3 lg:space-x-0 rtl:space-x-reverse">
            <span className="hidden lg:flex items-center space-x-3 rtl:space-x-reverse">
              <NavLink to={"https://trycomicfy.com"}>
                <BlueOutlinedButton label="Apply for Pilot Program" />
              </NavLink>
              <NavLink to={"/signup"}>
                <BlueOutlinedButton label="Sign Up" />
              </NavLink>
              <NavLink to={"/login"}>
                <BlueButton
                  testId="login"
                  width="120px"
                  label="Login"
                  height="45px"
                  onClick={handleMenu}
                />
              </NavLink>
            </span>
            <button
              onClick={handleMenu}
              data-collapse-toggle="navbar-sticky"
              type="button"
              className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
              aria-controls="navbar-sticky"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              {menuOpen ? <IoClose size={24} /> : <IoMenu size={24} />}
            </button>
          </div>
          <div
            className={`items-center justify-between w-full lg:flex lg:w-auto lg:order-1 ${
              menuOpen ? "" : "hidden"
              }`}
            id="navbar-sticky"
          >
            <ul className="flex gap-4 lg:gap-0 flex-col p-4 lg:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 lg:space-x-8 rtl:space-x-reverse lg:flex-row lg:mt-0 lg:border-0 lg:bg-white dark:bg-gray-800 lg:dark:bg-gray-900 dark:border-gray-700">
              <li>
                <Link
                  to="/"
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    setActiveMenuItem("hero");
                    handleMenu();
                  }}
                  className={`navitem ${
                    activeMenuItem === "hero" || activeMenuItem === ""
                      ? "active"
                      : ""
                    }`}
                  style={{ cursor: "pointer" }}
                >
                  Home
                </Link>
              </li>

              <li>
                <Link
                  to="/#how-it-works"
                  onClick={() => {
                    setActiveMenuItem("how-it-works");
                    handleMenu();
                  }}
                  className={`navitem ${
                    activeMenuItem === "how-it-works" ? "active" : ""
                    }`}
                >
                  How It Works
                </Link>
              </li>
              <li>
                <Link
                  to="/#features"
                  onClick={() => {
                    setActiveMenuItem("features");
                    handleMenu();
                  }}
                  className={`navitem ${
                    activeMenuItem === "features" ? "active" : ""
                    }`}
                >
                  Features
                </Link>
              </li>
              <li>
                <Link
                  to="/#pricing"
                  onClick={() => {
                    setActiveMenuItem("pricing");
                    handleMenu();
                  }}
                  className={`navitem ${
                    activeMenuItem === "pricing" ? "active" : ""
                    }`}
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/help"
                  onClick={() => {
                    setActiveMenuItem("help");
                    handleMenu();
                  }}
                  className={`navitem ${
                    activeMenuItem === "help" ? "active" : ""
                    }`}
                >
                  Support
                </Link>
              </li>
              <span className="flex flex-col sm:flex-row items-center justify-center mt-5 space-y-3 sm:space-y-0 sm:space-x-3 rtl:space-x-reverse lg:hidden">
                <NavLink to={"https://trycomicfy.com"}>
                  <BlueOutlinedButton label="Apply for Pilot Program" />
                </NavLink>
                <NavLink to={"/signup"}>
                  <BlueOutlinedButton label="Sign Up" className="min-w-[140px]"/>
                </NavLink>
                <NavLink to={"/login"}>
                  <BlueButton
                    testId="login"
                    label="Login"
                    height="45px"
                    onClick={handleMenu}
                  />
                </NavLink>
              </span>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default HomeNav;
